// extracted by mini-css-extract-plugin
module.exports = {"container":"loadingspinner_container__O8JBr","containerBg":"loadingspinner_containerBg__3DoUj","box":"loadingspinner_box__3L_8g","spinner":"loadingspinner_spinner__Mk6qp"};